import { render, staticRenderFns } from "./TabsCategory.vue?vue&type=template&id=662a5834&"
import script from "./TabsCategory.vue?vue&type=script&lang=js&"
export * from "./TabsCategory.vue?vue&type=script&lang=js&"
import style0 from "./TabsCategory.vue?vue&type=style&index=0&id=662a5834&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports